module.exports = __webpack_public_path__ + "ccf7f92dad9f4f05a6a85ef04dc44ee1.jpg";